import { render, staticRenderFns } from "./RegisterHomepage.vue?vue&type=template&id=4f4d3857&"
import script from "./RegisterHomepage.vue?vue&type=script&lang=js&"
export * from "./RegisterHomepage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports